import { render, staticRenderFns } from "./applyUpdate.vue?vue&type=template&id=36a5b33b&scoped=true"
import script from "./applyUpdate.vue?vue&type=script&lang=js"
export * from "./applyUpdate.vue?vue&type=script&lang=js"
import style0 from "./applyUpdate.vue?vue&type=style&index=0&id=36a5b33b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a5b33b",
  null
  
)

export default component.exports